module.exports = __webpack_public_path__ + "static/katarzyna_greczka-d7ffe2d6e8a4a44b290e59323c8bc573.png";